import { createContext } from 'react';

import { TAiReviewDto, TPrototypeDto } from '@app-velocity/av-api-v2';

export type SimulationContextType = {
  mode: 'authorized' | 'guest';
  scenario: TPrototypeDto;
  review?: TAiReviewDto;
  reviewedPageId?: string;
};

export const SimulationContext = createContext<SimulationContextType>({
  mode: 'guest',
  scenario: {},
});
